import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { summaryEntriesSelector, isJeLayoutRTLSelector } from 'domain/journal';
import { rtlEnable } from 'domain/env';

import { getMetaRange } from 'components/Tables/helpers';
import { getDataCell, isActive, isMandatory } from 'components/Tables/layout/helpers';

import JETable from 'components/Tables/grid/JETable';
import { SummaryTableLayout, JETableOverride } from 'components/Tables/layout/JESummaryTable/StyledComponents';
import { JE_TABLE_CLASSES } from 'components/Tables/grid/StyledComponents';
import { renderColgroup } from 'components/Tables/layout/component';

import cx from 'classnames';

const DEFAULT_COLUMN = ['A', 'B', 'C', 'D'];

class JESummaryTable extends React.Component {
  get isRevers() {
    return this.props.isJeLayoutRTL && this.props.rtl;
  }

  get meta() {
    const defColumn = this.isRevers ? DEFAULT_COLUMN.slice().reverse() : DEFAULT_COLUMN;
    const [column, row] = getMetaRange(this.props.data, this.isRevers);
    return [column.length < 4 ? defColumn : column, row];
  }

  getCellStyle = (col, row) => {
    const { active } = this.props;
    const entry = this.getData(row, col);
    return cx({
      [JE_TABLE_CLASSES.CELL_MANDATORY]: isMandatory(entry),
      [JE_TABLE_CLASSES.CELL_ACTIVE]: isActive(col, row, active),
    });
  };

  getData = (row, col) => getDataCell(this.props.data, row, col);

  getItem = (row, col) => this.props.getItem(this.getData(row, col));

  colgroup = () => {
    return renderColgroup([{ id: 'A', span: this.meta[0].length }]);
  };

  render() {
    return (
      <SummaryTableLayout>
        <JETableOverride>
          <JETable meta={this.meta} getCellStyle={this.getCellStyle} getItem={this.getItem} colgroup={this.colgroup} />
        </JETableOverride>
      </SummaryTableLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  data: summaryEntriesSelector(state),
  isJeLayoutRTL: isJeLayoutRTLSelector(state),
  rtl: rtlEnable(state),
});

export default compose(connect(mapStateToProps))(JESummaryTable);
